import type { SxProps, Theme } from '@mui/material/styles';
import {
  GLASS_BACKGROUND,
  GLASS_BLUR,
  NAVY,
  RADIUS_COIN,
  SHADOW,
  SURFACE,
  SURFACE_CONTAINER_LOW,
  SURFACE_CONTAINER_LOWEST,
  YELLOW,
} from 'styles/tokens';

// ── Re-exports (backward compat for step components) ──
export { NAVY, YELLOW } from 'styles/tokens';

export const SURFACE_BASE = SURFACE;
export const SURFACE_LOW = SURFACE_CONTAINER_LOW;
export const SURFACE_CARD = SURFACE_CONTAINER_LOWEST;

export const NAVY_SHADOW = SHADOW;
export const NAVY_SHADOW_STRONG = '0px 12px 32px rgba(21, 24, 58, 0.12)';

// ── Button Styles ──
export const primaryButtonSx: SxProps<Theme> = {
  bgcolor: YELLOW,
  color: NAVY,
  borderRadius: RADIUS_COIN,
  px: 4,
  py: 1.2,
  textTransform: 'none',
  fontWeight: 700,
  fontSize: '0.95rem',
  boxShadow: SHADOW,
  '&:hover': {
    bgcolor: '#e0bb09',
    boxShadow: NAVY_SHADOW_STRONG,
  },
  '&.Mui-disabled': {
    bgcolor: '#E0E0E0',
    background: '#E0E0E0',
    color: 'rgba(21, 24, 58, 0.4)',
  },
};

export const secondaryButtonSx: SxProps<Theme> = {
  bgcolor: NAVY,
  color: '#fff',
  borderRadius: RADIUS_COIN,
  px: 4,
  py: 1.2,
  textTransform: 'none',
  fontWeight: 700,
  fontSize: '0.95rem',
  boxShadow: SHADOW,
  '&:hover': {
    bgcolor: '#2a2d52',
  },
  '&.Mui-disabled': {
    bgcolor: '#E0E0E0',
    background: '#E0E0E0',
  },
};

export const backButtonSx: SxProps<Theme> = {
  borderColor: NAVY,
  color: NAVY,
  borderRadius: RADIUS_COIN,
  px: 3,
  textTransform: 'none',
  fontWeight: 600,
  '&:hover': {
    borderColor: NAVY,
    bgcolor: 'rgba(21, 24, 58, 0.04)',
  },
};

export const inlineActionButtonSx: SxProps<Theme> = {
  bgcolor: NAVY,
  color: '#fff',
  borderRadius: RADIUS_COIN,
  px: 3,
  textTransform: 'none',
  fontWeight: 600,
  '&:hover': {
    bgcolor: '#2a2d52',
  },
};

// ── Section Container Styles ──
export const sectionSx: SxProps<Theme> = {
  bgcolor: SURFACE_CONTAINER_LOW,
  borderRadius: RADIUS_COIN,
  p: { xs: 2, md: 2.5 },
  mb: 2,
  '& .MuiOutlinedInput-root': {
    borderRadius: '0.75rem',
    bgcolor: SURFACE_CONTAINER_LOWEST,
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: NAVY,
    },
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: NAVY,
  },
};

export const sectionTitleSx: SxProps<Theme> = {
  mb: 2,
  fontWeight: 600,
  color: NAVY,
  display: 'flex',
  alignItems: 'center',
  gap: 0.75,
  fontSize: '0.9rem',
};

export const sectionIconSx: SxProps<Theme> = {
  fontSize: 18,
  color: NAVY,
};

// ── Glassmorphism ──
export const glassmorphismPaperSx: SxProps<Theme> = {
  borderRadius: 3,
  bgcolor: GLASS_BACKGROUND,
  backdropFilter: GLASS_BLUR,
  boxShadow: NAVY_SHADOW_STRONG,
};

export const glassmorphismBackdropSx: SxProps<Theme> = {
  bgcolor: 'rgba(21, 24, 58, 0.3)',
  backdropFilter: 'blur(12px)',
};
